import { Box, Typography, useTheme } from "@mui/material";
import logoimage from "../../../../media/images/logo-image-v2.0.0.png";

import ModalLayout from "../../../components/ModalLayout";
import CustomButton from "../../../components/CustomButton";
import { rules } from "../../Terms";
interface Props {
  open: boolean;
  handleClose: () => void;
}

// const style = {
//   position: "absolute" as "absolute",
//   display: "flex",
//   flexDirection: "column",
//   top: "50%",
//   left: "50%",
//   flex: "1",
//   transform: "translate(-50%, -50%)",
//   maxWidth: 400,
//   minWidth: 350,
//   height: "300px",
//   border: "2px solid #000",
//   bgcolor: "background.paper",
//   boxShadow: 24,
//   borderRadius: "15px",
//   p: 2,
// };

export default function RulesModal({ open, handleClose }: Props) {
  const theme = useTheme();
  return (
    <ModalLayout open={open} setOpen={handleClose}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <img width={50} src={logoimage} alt="" />
        <Box>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "700",
              color: "primary.main",
            }}
          >
            قوانین و مقررات بازارگاه کارن ترابر نت
          </Typography>
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: "500",
            }}
          >
            آخرین بروزرسانی: 1 شهریور 1403
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          flex: "1",
          backgroundColor: theme.palette.bgColor.blueGrey50,
          borderRadius: "10px",
          overflow: "auto",
          mt: 3,
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "700",
            color: "primary.main",
            textAlign: "center",
            width: "70%",
            mx: "auto",
          }}
        >
          مقررات و شرایط استفاده از سامانه بازارگاه کارن ترابر نت :{" "}
        </Typography>
        <Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "justify",
            }}
          >
            این مقررات به‌منظور تنظیم روابط حقوقی میان صاحبان کالا، رانندگان
            وسایل نقلیه باری، شرکت‌های حمل‌ونقل و سامانه کارن ترابر نت تدوین
            گردیده و ثبت‌نام یا استفاده از خدمات سامانه به منزله قبول و التزام
            قطعی کاربران به مفاد این سند است.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginTop: "12px",
            gap: "16px",
          }}
        >
          {rules.map((item) => (
            <Box>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                }}
              >
                {item.title}
              </Typography>
              {item.description.map((desc, index) => (
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: "600",
                    textAlign: "justify",
                  }}
                >
                  {index + 1}-{desc}
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
      <CustomButton
        // loading={loading}
        onClick={() => {
          handleClose();
        }}
        flexDirection="row"
        title="بستن"
        justifyContent="space-between"
        bgColor="#fff"
        width="fit-content"
        fSize="14px"
        fWeight="700"
        textColor="error.main"
        borderColor="error.main"
        px="16px"
        py="6px"
        mt="0px"
        mr="auto"
        ml="auto"
        borderRadius="10px"
      />
    </ModalLayout>
  );
}
